module.exports = __webpack_public_path__ + "img/client6.6f61c6ff.png";